export default __webpack_public_path__ + "static/media/330_dummy2016-grafikdesigner01-mobile-de.1ed2067c.png";